import React from 'react'
import Picture from '../../components/Picture'
import './SingleTestimonialCard.scss'

const SingleTestimonialCard = ({
  text,
  stars,
  personName,
  companyName,
  personImage,
  className = '',
  testimonialElementType = 'h4'
}) => {
  return (
    <div className={`single-testimonial-card ${className}`}>
      <div className="testimonial-content">
        {stars && <div className="testimonial-stars" aria-hidden="true">{stars}</div>}
        {React.createElement(testimonialElementType, { className: "testimonial-text" }, `"${text}"`)}
        <div className="testimonial-author">
          {personImage && (
            <Picture
              src={personImage}
              alt={personName}
              className="author-image"
            />
          )}
          <div className="author-info">
            <div className="author-name">{personName}</div>
            {companyName && <div className="author-company">{companyName}</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SingleTestimonialCard



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/TwoCols/SingleTestimonialCard.jsx